import React from "react";
import ContactSection from "../sections/ContactSection";
import { useContent } from "../ContentContext";
import DarkFooter from "../sections/DarkFooter";

const HomePage = () => {
  const content = useContent();
  return (
    <div className="bg-dark text-light min-h-screen">

      {/* Homepage Section */}
      <section className="relative text-center h-screen bg-light text-white">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster="/videos/homepage.png"
        >
          <source src="/videos/homepage.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Overlay Layer */}
        <div className="absolute inset-0 bg-dark opacity-70"></div>

        {/* Overlay Content */}
        <div className="relative max-w-6xl mx-auto flex flex-col items-center justify-center h-full px-4">
          {/* Text Content */}
          <p className="uppercase text-lg sm:text-2xl tracking-wide font-garet relative">
            {content.homepage.subtitle}
          </p>
          <h1 className="text-4xl sm:text-7xl my-4 font-bodoni relative">{content.homepage.title}</h1>
        </div>
      </section>

      {/* Main Content Section */}
      
          {content.homepagesections.map((section, index) => {
            // Determine background, text, and border colors
            const bgColor =
              index % 3 === 0
                ? "bg-dark"
                : index % 3 === 1
                ? "bg-light"
                : "bg-secondary";
            const textColor = index % 3 === 0 || index % 3 === 2 ? "text-light" : "text-dark";
            const borderColor = index % 3 === 0 || index % 3 === 1 ? "border-primary" : "border-light";

            return (
              <section className={`${bgColor} ${textColor} `}>
                <div className="p-4 max-w-4xl mx-auto grid grid-cols-1 h-auto lg:h-screen">
                  <div
                    key={index}
                    className={` flex flex-col justify-center h-full`}
                  >
                    <div className={`relative p-8  `}>
                      {/* Top-Left Border */}
                      <div
                        className={`absolute top-0 left-0 w-12 h-12 border-t-4 border-l-4 ${borderColor}`}
                      ></div>

                      {/* Bottom-Right Border */}
                      <div
                        className={`absolute bottom-0 right-0 w-12 h-12 border-b-4 border-r-4 ${borderColor}`}
                      ></div>

                      {/* Content */}
                      <h3 className="text-2xl sm:text-4xl font-bodoni font-bold mb-2">
                        {section.title}
                      </h3>
                      {section.description.map((paragraph, index) => (
                        <p key={index} className="text-1xl sm:text-2xl font-garet">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            );
          })}
        


      {ContactSection()}
      {DarkFooter()}
      
      
    </div>
  );
};

export default HomePage;
